import React, { useContext } from "react";
import { FaHeartbeat, FaBriefcaseMedical, FaHandHoldingHeart, FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./aid.jpg";

const FirstAid: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/first-aid');
    } else {
      navigate('/login', { state: { from: '/booking/first-aid' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Critical Skill</span>
          <h1 className="hero-title">First Aid Training</h1>
          <p className="hero-subtitle">
            The difference between life and death often happens in the first few minutes.
            Learn to stabilize injuries and manage emergencies until professionals arrive.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Golden Hour</h2>
              <p className="article-text">
                First aid isn't surgery; it's stabilization. The goals are:
                <strong>Preserve Life</strong> (Airway, Breathing, Circulation),
                <strong>Prevent Worsening</strong> (bleeding control, immobilization), and
                <strong>Promote Recovery</strong> (reassurance, shock management).
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">DRSABCD Action Plan</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>D</strong>anger: Check for safety (fire, wire, gas).</li>
                  <li><strong>R</strong>esponse: Is the casualty conscious?</li>
                  <li><strong>S</strong>end for Help: Call Emergency immediately.</li>
                  <li><strong>A</strong>irway: Open mouth, clear obstructions.</li>
                  <li><strong>B</strong>reathing: Check for rise/fall of chest.</li>
                  <li><strong>C</strong>PR: 30 compressions : 2 breaths.</li>
                  <li><strong>D</strong>efibrillation: Attach AED if available.</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Treating Trauma</h2>
              <p className="article-text">
                <strong>Bleeding:</strong> Apply direct pressure. Elevate limb.
                <strong>Burns:</strong> Cool with running water for 20 mins. Cover with cling wrap.
                <strong>Fractures:</strong> Immobilize. Don't straighten the limb. Support with splint.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Kit Essentials</h4>
              <ul className="key-list">
                <li><FaBriefcaseMedical className="check-icon" /> Sterile Bandages</li>
                <li><FaHeartbeat className="check-icon" /> CPR Face Shield</li>
                <li><FaHandHoldingHeart className="check-icon" /> Antiseptic Wipes</li>
                <li><FaPhoneAlt className="check-icon" /> Emergency Numbers</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ borderColor: '#ff4444' }}>
              <h4 className="widget-title" style={{ color: '#ff4444' }}>CPR Failure</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                For every minute without CPR during arrest, survival drops by 10%.
                <strong>Push Hard, Push Fast.</strong>
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Be A Lifesaver</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Get certified and be ready to act.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FirstAid;
